import { Breadcrumbs } from 'components/Breadcrumbs/Breadcrumbs';
import { Container } from 'components/Container/Container';
import { PageTitle } from 'components/PageTitle/PageTitle';
import { useTranslation } from 'react-i18next';

import { Anniversaries } from './_components/Anniversaries';
import { DashboardEvents } from './_components/DashboardEvents';
import { DraftMembers } from './_components/DraftMembers';
import { ExpiringMemberships } from './_components/ExpiringMemberships';
import { LastDayRevenue } from './_components/LastDayRevenue';
import { LowestBalances } from './_components/LowestBalances';
import { MonthlyIncome } from './_components/MonthlyIncome';
import { NegativeBalances } from './_components/NegativeBalances';
import { NewMembersList } from './_components/NewMembersList';
import { RemainderBalances } from './_components/RemainderBalances';
import { RevenueTable } from './_components/RevenueTable';
import { YearlyRevenue } from './_components/YearlyRevenue';

export const Dashboard = () => {
    const { t } = useTranslation('dashboard');
    const { t: b } = useTranslation('translation');
    return (
        <Container>
            <Breadcrumbs crumbs={[b('breadcrumbs.dashboard')]} />
            <PageTitle>{t('title')}</PageTitle>

            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-6 lg:flex-row">
                    <div className="flex flex-col gap-6 w-full lg:w-[44%]">
                        <DraftMembers />
                        <NegativeBalances />
                    </div>
                    <Anniversaries />
                </div>

                <div className="flex flex-col lg:flex-row gap-6">
                    <NewMembersList />
                    <ExpiringMemberships />
                </div>
                <div className="flex flex-col lg:flex-row gap-6">
                    <LastDayRevenue />
                    <MonthlyIncome />
                    <YearlyRevenue />
                </div>
                <RevenueTable />
                <div className="flex flex-col lg:flex-row gap-6">
                    {/* <UnpaidInvoices /> */}
                    <div className="flex flex-col gap-6 w-full lg:w-[44%]">
                        <LowestBalances />
                    </div>
                    <RemainderBalances />
                </div>
                <DashboardEvents />
            </div>
        </Container>
    );
};
